<script>
  import { onMount, createEventDispatcher } from 'svelte'
  import Cookies from 'js-cookie'
  import Api from './services/Api.js'

  import { auth } from './stores/root.js'

  let username, password, remember, loading

  async function handleSubmit() {
    Cookies.remove('jwt')
    Cookies.remove('user')

    loading = true

    await Api.post('/auth/local', {
      identifier: username.toLowerCase(),
      password: password,
    })
      .then(({ data }) => {
        let expires
        if (data.user.location || remember) expires = { expires: 30 }

        Cookies.set('jwt', data.jwt, expires)
        Cookies.set('user', JSON.stringify(data.user), expires)

        auth.set(data)
      })
      .catch(() => {
        loading = false
        alert('Invalid username or password.  Please try again')
      })
  }
</script>

<div class="signin-wrapper">
  <main class="form-signin d-flex flex-column align-items-center">
    <img class="mb-2" src="images/logo.png" alt="Twin Sisters Market" />
    <form on:submit|preventDefault={handleSubmit}>
      <div class="form-floating">
        <input
          type="text"
          class="form-control"
          id="floatingInput"
          placeholder="User Name"
          bind:value={username}
        />
        <label for="floatingInput">User Name</label>
      </div>
      <div class="form-floating">
        <input
          type="password"
          class="form-control"
          id="floatingPassword"
          placeholder="Password"
          bind:value={password}
        />
        <label for="floatingPassword">Password</label>
      </div>

      <div class="checkbox mb-3">
        <label>
          <input type="checkbox" value="remember-me" bind:checked={remember} /> Remember
          me
        </label>
      </div>
      <button class="w-100 btn btn-lg btn-primary" type="submit">
        {#if loading}
          <div
            class="spinner-border spinner-border-sm text-light"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        {:else}
          Sign in
        {/if}
      </button>
    </form>
  </main>
</div>

<style>
  .signin-wrapper {
    display: flex;
    align-items: center;
    height: 100vh;
    background: rgb(245, 240, 235);
  }

  .form-signin {
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: auto;
  }

  .form-signin .checkbox {
    font-weight: 400;
  }

  .form-signin .form-floating:focus-within {
    z-index: 2;
  }

  .form-signin input[type='text'] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .form-signin input[type='password'] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .form-signin button {
    font-size: 16px;
  }

  img {
    max-width: 200px;
    width: 100%;
    height: auto;
  }

  form {
    width: 100%;
  }
</style>
